(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/shared/components/big-icon.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/shared/components/big-icon.js');
'use strict';

const ReactIcon = svs.ui.ReactIcon;

const BigIcon = _ref => {
  let icon = _ref.icon;
  return React.createElement("div", {
    className: "align-center padding-top-2 padding-bottom-1 margin-bottom"
  }, React.createElement(ReactIcon, {
    icon: icon,
    size: "900"
  }));
};
svs.myProfile.react.shared.components.BigIcon = BigIcon;

 })(window);